import React, { useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  getChats,
  getMessages,
  getHistoryMessages,
  markGroupAsRead,
  putMessage,
  addingIsFinished,
  getChatById,
  getSystemMessages,
  getSystemAnswer,
} from "../../core/repository/ChatRepository"
import ModalAlert from "../../components/ModalAlert"
import { useProjectsByUser, useUsers } from "../../core/utils/hooks/useUsers"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import { sort } from "fast-sort"
import { updateItem } from "../../core/firebase/functions"
import { storage, db } from "../../core/firebase"
import moment from "moment"
import Send from "../../core/communication"
import { useDispatch, useSelector } from "react-redux"
import { customToast } from "../../components/Toast"
import NewChatScreen from "../../screen/NewChatScreen"
import { debounce } from "lodash"
import { getHighlightedTextList } from "../../components/HighlightedText"
import { toast } from "react-toastify"
import { useChatContext } from "../../core/context/chatContext"
import { handleRemoveSavedTestimonials, handleSaveTestimonials } from "../../core/services/testimonials.service"
import { setData } from "../../core/redux/app/Actions"
import { useTagsByProject } from "../../core/utils/hooks/useTags"
import { useForm } from "react-hook-form"
import { useAssistancePlanContext } from "../../core/context/assistancePlanContext"
import EditUserModal from "../../components/EditUserModal"
import { useWhatsAppAccess } from "../../core/utils/hooks/useWhatsAppAccess"

const useOtherUser = (loggedUser = {}, scopeId, scopeType) => {
  const [tab, setTab] = useState(loggedUser.id)
  const [availableIds, setAvailableIds] = useState([])

  const getAvailableIds = async () => {
    const ids = [{ id: loggedUser.id, name: loggedUser.name }]

    setAvailableIds(ids)
  }

  useEffect(() => {
    if (scopeId) {
      setTab(loggedUser.id)
      setAvailableIds([])
      getAvailableIds()
    }
    return () => setAvailableIds([])
  }, [scopeId])

  return [
    availableIds.map(({ id }) => id).filter((id) => id === tab)[0] || loggedUser?.id,
    availableIds.filter(({ id }) => id === tab)[0]?.name || loggedUser?.name,
    tab,
    setTab,
    [
      {
        id: loggedUser.id,
        name: "Minhas Conversas",
      },
      ...availableIds.filter((item) => item?.id !== loggedUser?.id),
    ],
  ]
}

const template = {
  title: "*Assistência*:",
  message: `*Assistência*:
 
    {{1}}
     
    👩‍🌾`,
}

export const cleanMessageTemplate = (message) => {
  if (!message)
    return "Mensagem não suportada: O beneficiário enviou uma mídia que não é compatível com a plataforma. Por isso, a mensagem não pôde ser exibida corretamente."

  // Remover texto entre asteriscos seguido de dois pontos (ex: "*texto*:")
  const noAsterisksText = message.replace(/\*[^*]*\*:/g, "")

  // Regex para remover todos os emojis (cobrindo uma gama mais ampla de caracteres Unicode)
  const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu

  // Remover emojis do texto
  const cleanedText = noAsterisksText.replace(emojiRegex, "").trim()

  return cleanedText !== ""
    ? cleanedText
    : "Mensagem não suportada: O beneficiário enviou uma mídia que não é compatível com a plataforma. Por isso, a mensagem não pôde ser exibida corretamente."
}


const NewChatContainer = ({
  showOnlyChat = false,
  defaultChat = null,
  changeCurrentChat,
  indicators,
  showActions,
  handleCloseModal,
  isMobile = false,
  formQuestionMessage = {}
}) => {
  const navigate = useNavigate()
  const messageRef = {}
  const { scope, scopeType } = useScope()
  const { pathname } = useLocation()
  const loggedUser = useUser()
  const { instanceName } = useWhatsAppAccess()
  const [chat, setChat] = useState(false)
  const [userId, userName, tab, setTab, tabOptions] = useOtherUser(loggedUser, scope?.id, scopeType)
  console.log({userId, userName})
  const { projectsByUser } = useProjectsByUser(userId)
  const { projects } = useSelector((state) => state.app)
  const reduxUser = useSelector((state) => state.app.user || {})
  
  // Debug log para verificar projectsByUser
  console.log('Debug - projectsByUser:', projectsByUser, 'userId:', userId)
  console.log('Debug - projectsByUser detailed:', JSON.stringify(projectsByUser, null, 2))
  const { tags } = useTagsByProject()
  const [reload, setReload] = useState(false)
  const [messages, setMessages] = useState([])
  const [channels, setChannels] = useState([])
  const [values, setValues] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState(false)
  const [loadingDeleteMessage, setLoadingDeleteMessage] = useState(false)
  const [openPicker, setOpenPicker] = useState(false)
  const { users } = useUsers()
  const messageSortDesc = sort(messages).asc((u) => new Date(u.date * 1000))
  const messageSortAsc = sort(messages).asc((u) => new Date(u.date * 1000))
  const [read, setRead] = useState(false)
  const [modalFilterIsOpen, setModalFilterIsOpen] = useState(false)
  const [formatedTags, setFormatedTags] = useState([])
  const [selectedTag, setSelectedTag] = useState("")
  const [selectedTagException, setSelectedTagException] = useState("")
  const [usersByTagException, setUsersTagException] = useState([])
  const [tagsToFilter, setTagsToFilter] = useState(false)
  const [filterMessages, setFilterMessages] = useState("")
  const [inputMessage, setInputMessage] = useState("")
  const [openHistory, setOpenHistory] = useState(false)
  const [openSearch, setOpenSearch] = useState(false)
  const [numberOfChats, setNumberOfChats] = useState({ active: 0 })
  const [messageModalIsOpen, setMessageModalIsOpen] = useState(false)
  const [modalNewsIsOpen, setModalNewsIsOpen] = useState(false)
  const [modalTermsIsOpen, setModalTermsIsOpen] = useState(false)
  const [modalMagicLinkIsOpen, setModalMagicLinkIsOpen] = useState(false)
  const [filteredMsgPosition, setFilteredMsgPosition] = useState({ messages: [], index: 0 })
  const [messageModalOpen, setMessageModalOpen] = useState(false)
  const [openText, setOpenText] = useState(false)
  const [openVoice, setOpenVoice] = useState(false)
  const [isSystemChat, setIsSystemChat] = useState(false)
  const [openModalTestimonialSave, setOpenModalTestimonialSave] = useState(false)
  const [projectsList, setProjectsList] = useState([])
  const dispatch = useDispatch()
  const {
    openNewAssistance,
    setOpenNewAssistance,
    addNewPinnedMessage,
    pinnedMessages,
    resetPinnedMessages,
    evidenceId,
    saveOnlyOneMessage,
    pinnedMessagesQuestions,
    resetPinnedMessagesQuestions,
    channelLoading,
    setChannelLoading,
    moreChannelLoading,
    setMoreChannelLoading,
    setIsLoadingMessages,
    setUpdatedMessages,
    setFavoritedMessages,
    favoritedMessages,
    setEnabledIntegration,
    setIsLoadingTestimonial,
    enableIntegration
  } = useChatContext()


  const [tagLinkIsOpen, setModalTagLinkIsOpen] = useState(false)
  const [resetFields, setResetFields] = useState(false)
  const [editUserModalOpen, setEditUserModalOpen] = useState(false)
  const [userToEdit, setUserToEdit] = useState(null)
  
  // Initialize quick filter state from localStorage
  const getStoredQuickFilterState = () => {
    try {
      const stored = localStorage.getItem(`chat-quick-filter-${loggedUser?.id || 'default'}`)
      return stored === 'true'
    } catch (error) {
      console.warn('Failed to read quick filter state from localStorage:', error)
      return false
    }
  }
  
  const [isQuickFilterActive, setIsQuickFilterActive] = useState(getStoredQuickFilterState)

  const { register, getValues, watch, setValue } = useForm({
    mode: "onChange",
  })

  const handleNavigateToEvidence = () => {
    handleCloseModal()
  }

  const createdAt = messageSortAsc
    .filter((item) => item && item?.idChat === chat?.id)
    .map((item) => {
      return {
        ...item,
        createdAt: moment(new Date(item && item.date && item.date.seconds * 1000)).format(
          "DD/MM/YYYY",
        ),
      }
    })
    .filter(function (a) {
      return !this[JSON.stringify(a.createdAt)] && (this[JSON.stringify(a.createdAt)] = true)
    }, Object.create(null))

  const loadDefaultChat = async (chatId) => {
    try {
      setChannelLoading(true)
      let result = await getChatById(chatId)
      let readByUser = result?.latestMessage?.readByUsers
        ? result?.latestMessage?.readByUsers.filter((row) => row === loggedUser.id)
        : []

      if (result?.id !== result?.latestMessage?.user) readByUser = [1]

      readByUser = readByUser.length ? true : false

      if (result.lastMessageUserDate) {
        const { seconds, nanoseconds } = result.lastMessageUserDate
        const timestamp = seconds * 1000 + Math.floor(nanoseconds / 1e6)
        const startTime = moment(timestamp)
        const endTime = startTime.clone().add(24, "hours")
        const duration = moment.duration(endTime.diff(moment()))

        const hours = Math.floor(duration.asHours())
        const minutes = duration.minutes()

        result.timeRemaining = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
      }

      const shouldFilter = result?.projectIds?.length > 1

      const filterById = (id) => projects.some((proj) => proj.id === id)
      const filterByName = (name) => projects.some((proj) => proj.description === name)

      const checkProjects = {
        projectIds: shouldFilter ? result?.projectIds.filter(filterById) : result?.projectIds,
        projectNames: shouldFilter ? result?.projectNames.filter(filterByName) : result?.projectNames,
      }

      result = {
        id: result?.id,
        name: result?.name,
        status: 1,
        unreadCount: result?.unreadCount || 0,
        date: result?.latestMessage?.date?.toDate(),
        message: result?.latestMessage?.content,
        projectId: result?.latestMessage?.project,
        ...checkProjects,
        isFinished: result?.isFinished,
        lastMessageDate: result.timeRemaining,
        latestMessage: result?.latestMessage?.id,
        readByUser,
      }

      setChat(result)
    } catch (error) {
      console.log("Erro ao buscar conversas", error)
    }
    finally {
      setChannelLoading(false)
    }

  }

  useEffect(() => {
    setReload(!reload)
    setOpenText(false)
    setOpenVoice(false)
  }, [messages && messages.length, scope?.id, users && users.length])

  useEffect(() => {
    setMessages([])
    setChat(false)
  }, [read])

  useEffect(() => {
    if (defaultChat) {
      loadDefaultChat(defaultChat)
    } else if (!showOnlyChat && isMobile) {
      // Limpa o chat quando volta para a lista no mobile
      setChat(false)
      dispatch(
        setData({
          chat: false,
        }),
      )
    }
  }, [defaultChat])

  useEffect(() => {
    if (users && loggedUser?.id && !showOnlyChat) {
      loadChannels(read)
    }
  }, [tab, scope?.id, users && users.length, loggedUser?.id, read, showOnlyChat])

  // Recarregar chats quando projectsByUser estiver disponível
  useEffect(() => {
    if (projectsByUser && projectsByUser.length > 0 && loggedUser?.id && !showOnlyChat) {
      console.log('projectsByUser mudou - recarregando chats:', projectsByUser)
      loadChannels(read)
    }
  }, [projectsByUser])

  useEffect(() => {
    const callback = (newMessages) => {
      setMessages((previous) => [
        ...newMessages.map((item) => {
          const message =
            typeof item.message === "object" ? { ...item, message: item?.message?.message } : item

          return {
            ...message,
            idChat: chat.id,
            nameSender: message?.username || message.userName || message.userEmail || "Usuário",
          }
        }),
        ...previous,
      ])
    }

    if (chat && chat.id) {
      loadMessages(callback)
    }

    return () => setMessages([])
  }, [chat && chat.id, openHistory, isSystemChat])

  useEffect(() => {
    setOpenHistory(false)
    setOpenSearch(false)
  }, [chat && chat.id])

  useEffect(() => {
    setFormatedTags(
      tags?.map(({ name, id, project }) => ({
        value: id,
        label: project && project.description ? `${name} - ${project?.description}` : name,
      })),
    )
  }, [tags?.length])

  useEffect(() => {
    if (values?.tagException && values?.tagException?.length > 0) {
      setTagsToFilter(false)
    }
  }, [values])


  const loadMessages = async (callback) => {
    if (chat && chat.id) {
      setIsLoadingMessages(true)

      if (openHistory) {
        try {
          const newMessages = await getHistoryMessages(chat.id)

          setMessages((previous) => [
            ...newMessages.map((item) => {
              const message =
                typeof item.message === "object" ? { ...item, message: item?.message?.message } : item

              return {
                ...message,
                content: message.message,
                user: message.fromUserId,
                idChat: chat.id,
                nameSender:
                  (chat.id === item.fromUserId ? chat.name : message.fromUserId) || "Técnico(a)",
              }
            }),
            ...previous,
          ])
        } catch (error) {
          console.error("Erro ao carregar histórico de mensagens:", error)
        } finally {
          setIsLoadingMessages(false)
        }
      } else {
        getMessages(
          chat.id,
          async (array) => {
            await callback(array)
            await markGroupAsRead(loggedUser.id, chat.id)
            setIsLoadingMessages(false)
          },
          (updatedMessage) => {
            setUpdatedMessages(prev => ({
              ...prev,
              [updatedMessage.id]: {
                ...updatedMessage
              }
            }));
            console.log({ updatedMessage }, "nova")
            setEnabledIntegration(updatedMessage)
          },
          (e) => {
            console.log("Error on retrieve chats", e)
            setIsLoadingMessages(false)
          },
          isSystemChat
        )
      }
    }
  }

  const loadChannels = async (read, resetChats = true) => {
    if (resetChats) setChannelLoading(true)
    else setMoreChannelLoading(true)

    try {
      // Combinar loggedUser com projectsByUser para ter a estrutura completa esperada por getChats
      // projectsByUser tem estrutura {label, value}, mas getChats espera {project: {id}}
      const transformedProjects = (projectsByUser || []).map(item => ({
        project: { id: item.value }
      }))
      
      const userWithProjects = {
        ...loggedUser,
        projectUser: transformedProjects,
        external_data: reduxUser.external_data,
        instance: instanceName
      }
      
      console.log('🔄 Dados transformados para getChats:', {
        originalProjectsByUser: projectsByUser,
        transformedProjects,
        userWithProjects: userWithProjects
      })
      const chats = await getChats(userWithProjects, read, !resetChats)
      
      // Tags already come from Firebase in the chat objects
      if (DEBUG_FILTER) {
        console.log(`Loaded ${chats.length} chats from Firebase`)
      }

      let allChats = chats.map((chat) => {
      let readByUser = chat.latestMessage?.readByUsers
        ? chat.latestMessage?.readByUsers.filter((row) => row === loggedUser.id)
        : []

      if (chat.id !== chat?.latestMessage?.user) readByUser = [1]

      readByUser = readByUser.length ? true : false

      if (chat.lastMessageUserDate) {
        const { seconds, nanoseconds } = chat.lastMessageUserDate
        const timestamp = seconds * 1000 + Math.floor(nanoseconds / 1e6)
        const startTime = moment(timestamp)
        const endTime = startTime.clone().add(24, "hours")
        const duration = moment.duration(endTime.diff(moment()))

        const hours = Math.floor(duration.asHours())
        const minutes = duration.minutes()

        chat.timeRemaining = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
      }

      const shouldFilter = chat?.projectIds?.length > 1

      const filterById = (id) => projects.some((proj) => proj.id === id)
      const filterByName = (name) => projects.some((proj) => proj.description === name)

      const checkProjects = {
        projectIds: shouldFilter ? chat?.projectIds.filter(filterById) : chat?.projectIds,
        projectNames: shouldFilter ? chat?.projectNames.filter(filterByName) : chat?.projectNames,
      }

      return {
        id: chat?.id,
        name: chat?.name,
        status: 1,
        unreadCount: chat?.unreadCount || 0,
        date: chat?.latestMessage?.date?.toDate(),
        message: cleanMessageTemplate(chat?.latestMessage?.content),
        projectId: chat?.latestMessage?.project,
        ...checkProjects,
        isFinished: chat?.isFinished,
        lastMessageDate: chat.timeRemaining,
        latestMessage: chat?.latestMessage?.id,
        readByUser,
        tags: chat?.tags && typeof chat.tags === 'object' && !Array.isArray(chat.tags) 
          ? Object.values(chat.tags) 
          : Array.isArray(chat?.tags) ? chat.tags : [],
      }
    })

    allChats = sort(allChats).desc((u) => u.date?.getTime())

    if (!read) {
      setNumberOfChats((curr) => ({
        active: allChats.length,
      }))
    }

      setChannels(allChats)

    } catch (error) {
      console.error('Error loading channels:', error)
      // Set empty channels in case of error
      setChannels([])
    } finally {
      if (resetChats) setChannelLoading(false)
      else setMoreChannelLoading(false)
    }
  }

  const onChange = (field, value) => {
    setValues({ ...values, [field]: value })
  }

  const onChangeFilterTags = useCallback((field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }, [])

  const loadusersByTagException = async () => {
    const tagIds = values?.tag?.map((item) => item.value) || []
    const exceptTagIds = values?.tagException?.map((item) => item.value) || []

    setChannelLoading(true)
    const response = await Send.post("/tags-user/except", {
      tagIds,
      exceptTagIds,
      yesOrNot: tagsToFilter,
    })

    if (response.length > 0) {
      setUsersTagException(response)
    } else {
      setUsersTagException([])
      customToast("Não há dados para filtrar com as tags fornecidas", "info")
    }

    setChannelLoading(false)
    setModalFilterIsOpen(false)
  }

  const loadTags = () => {
    loadusersByTagException()
  }

  const clearFields = () => {
    setUsersTagException([])
    setResetFields(true)
    setTagsToFilter(false)
    setModalFilterIsOpen(false)
  }

  const onKeyPress = (e) => {
    if (e && e.key === "Enter") {
      onSendMessages()
    }
  }

  const onSendMessages = async (e) => {
    if (inputMessage && inputMessage.trim() !== "") {
      const encapsulatedMessage = template.message?.replace("{{1}}", inputMessage)

      putMessage(
        chat,
        loggedUser,
        encapsulatedMessage,
        null,
        chat.users,
        chat.name,
        null,
        null,
        null,
        isSystemChat,
        null,
        "HX84ff16014247594cb094202cc54dc45a",
        null,
        instanceName
      )

      if (isSystemChat) {
        const chatMessages = await new Promise((resolve) => {
          getMessages(
            chat.id,
            async (array) => {
              resolve(array)
            },
            (updatedMessage) => {
              console.log({ updatedMessage }, "nova")
            },
            (e) => console.log("Error on retrive chats", e),
            false,
          )
        })

        const formattedIndicatores = {}

        Object.keys(indicators).map((key) => {
          const data = indicators[key].map((item) => {
            const { category, title, value, formQuestions } = item

            const questions =
              formQuestions &&
              formQuestions.map(({ question }) => ({
                title: question.title,
                answer: question.answer,
                options: [...question.options].map((item) => item.title),
              }))

            return {
              category,
              title,
              value,
              questions,
            }
          })

          formattedIndicatores[key] = data
        })

        //formStepsGrouped
        const context = `Possuímos uma escala de sustentabilidade. Esta escala utiliza uma nota de 0 a 100 para cada indicador e separa os indicadores em dimensões, temos a nota de sustentabilidade considerando os pesos de cada dimensão. Para o produtor atual, segue o JSON referente a escala: ${JSON.stringify(
          formattedIndicatores,
        )}
        Mensagens trocadas com esse produtor: ${JSON.stringify(
          chatMessages.map(({ content, userName, date }) => ({
            content,
            user: userName,
            date,
          })),
        )}
        Considerando que você é um especialista em agronomia e irá auxiliar outros especialistas respondendo como ele pode melhorar sustentabilidade desse produtor, responda a próxima pergunta, utilize texto simples para responder, sem markdown ou html.`
        await getSystemAnswer(chat, inputMessage, context)
      }

      setInputMessage("")
      setOpenText(false)
      setOpenVoice(false)
    } else if (values?.audio?.file) {
      const dataReference = `UploadField/:idFile`
      const uniqueFilename = values.audio.file.name
      const storageRef = storage.ref(dataReference).child(uniqueFilename)

      const contentType = "audio/mpeg"
      try {
        const taskSnapshot = await storageRef.put(values.audio.file, { contentType })
        const url = await taskSnapshot.ref.getDownloadURL()

        putMessage(
          chat,
          loggedUser,
          "Audio 📃",
          { remotePath: url, name: uniqueFilename, localPath: uniqueFilename, contentType },
          chat.users,
          chat.name,
          null,
          null,
          null,
          isSystemChat,
          null,
          null,
          null,
          instanceName
        )
      } catch (error) {
        console.error("Erro ao enviar áudio", error)
        customToast("Erro ao enviar áudio", "error")
      }
    }

    setReload((prev) => !prev)
    setValues((prev) => ({ ...prev, audio: { value: "" } }))
  }

  const resendMessage = (data) => {
    const { id, content, user, userName, userEmail, chat, attachment } = data

    const users = { name: userName, email: userEmail, id: user }

    const resend = { id, content }

    if (content && attachment) {
      const { contentType, remotePath, localPath, name } = attachment
      if (contentType && contentType.includes("image")) {
        putMessage(
          chat,
          loggedUser,
          "Imagem 🖼️",
          {
            remotePath,
            name,
            localPath,
            contentType,
          },
          null,
          null,
          null,
          null,
          null,
          false,
          resend,
          null,
          null,
          instanceName
        )
      } else if (contentType && contentType.includes("application")) {
        putMessage(
          chat,
          loggedUser,
          "Arquivo 📃",
          {
            remotePath,
            name,
            localPath,
            contentType,
          },
          null,
          null,
          null,
          null,
          null,
          false,
          resend,
          null,
          null,
          instanceName
        )
      } else if (contentType && contentType.includes("video")) {
        putMessage(
          chat,
          loggedUser,
          "Video 📃",
          {
            remotePath,
            name,
            localPath,
            contentType,
          },
          null,
          null,
          null,
          null,
          null,
          false,
          resend,
          null,
          null,
          instanceName
        )
      } else if (contentType && contentType.includes("audio")) {
        putMessage(
          chat,
          users,
          "Audio 📃",
          {
            remotePath,
            name,
            localPath,
            contentType,
          },
          null,
          null,
          null,
          null,
          null,
          false,
          resend,
          null,
          null,
          instanceName
        )
      }
    } else {
      putMessage(
        chat,
        users,
        content,
        null,
        null,
        null,
        null,
        null,
        null,
        false,
        resend,
        "HX84ff16014247594cb094202cc54dc45a",
        null,
        instanceName
      )
    }

    setReload((prev) => !prev)
  }

  const uploadFiles = async (file) => {
    const dataReference = "UploadField/:idFile"
    file.forEach((item) => {
      const name = item.name

      const uniqueFilename = imageNameUtils(name)
      const storageRef = storage.ref(dataReference).child(uniqueFilename)
      console.log("stor", storageRef)
      const task = storageRef.put(item)
      const contentType = file[0].type
      task.then(() => {
        storageRef.getDownloadURL().then((url) => {
          if (contentType && contentType.includes("image")) {
            putMessage(chat, loggedUser, "Imagem 🖼️", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            }, null, null, null, null, null, false, null, null, null, instanceName)
          } else if (contentType && contentType.includes("application")) {
            putMessage(chat, loggedUser, "Arquivo 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            }, null, null, null, null, null, false, null, null, null, instanceName)
          } else if (contentType && contentType.includes("video")) {
            console.log("stor", url)
            putMessage(chat, loggedUser, "Video 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            }, null, null, null, null, null, false, null, null, null, instanceName)
          } else if (contentType && contentType.includes("audio")) {
            putMessage(chat, loggedUser, "Audio 📃", {
              remotePath: url,
              name,
              localPath: uniqueFilename,
              contentType,
            }, null, null, null, null, null, false, null, null, null, instanceName)
          }
        })
      })
    })
    setReload(!reload)
  }

  const onDeleteMessage = async (message) => {
    ModalAlert.danger({
      title: "Excluir",
      text: "Você deseja mesmo excluir esta mensagem",
      confirmLabel: loadingDeleteMessage ? "Excluindo..." : "Sim",
      onConfirm: async () => {
        if (chat && chat.id && message && message.id) {
          try {
            setLoadingDeleteMessage(true)
            await updateItem(`users/${chat.id}/messages`, { id: message.id, deleted: true })
            setMessages((messages) => [...[{ ...message, deleted: true }], ...messages])
            setOpenPicker(false)
          } catch (error) {
            console.log("error", error)
          } finally {
            setLoadingDeleteMessage(false)
          }
        }
        setReload(!reload)
      },
    })
  }

  const newChat = async () => {
    if (scopeType !== "project") {
      customToast("Não é possível criar um chat sem selecionar um PROJETO", "error")
      return
    }

    setLoading(true)
    const usersNew = [{ id: userId }, chat]
    const group = await Send.post(`/projects/groups/${scope?.id}`, {
      user: userId,
      start_at: moment(new Date()).format("YYYY-MM-DD"),
      finish_at: "2040-01-01",
      status: 1,
      title: chat.name,
      image: "",
      project: scope?.id,
    }).then((response) => response)
    for (let i = 0; i < usersNew.length; i++) {
      await Send.post(`/projects/groups/user/${scope?.id}/${group.id}`, {
        group: group.id,
        user: usersNew[i].id,
        start_at: moment(new Date()).format("YYYY-MM-DD"),
        finish_at: "2040-01-01",
        status: 1,
        moderator: group.user === usersNew[i].id ? true : false,
      })
    }
    setChat(false)
    setReload(!reload)
    setLoading(false)
  }

  const onTab = (tab) => {
    setTab(tab)
    setChat(false)
    setMessages([])
  }

  const handleTagsToFilter = (e) => {
    setTagsToFilter(!tagsToFilter)
  }

  const onQuickFilterClick = () => {
    const newQuickFilterState = !isQuickFilterActive
    setIsQuickFilterActive(newQuickFilterState)
    
    // Save to localStorage
    try {
      localStorage.setItem(`chat-quick-filter-${loggedUser?.id || 'default'}`, newQuickFilterState.toString())
    } catch (error) {
      console.warn('Failed to save quick filter state to localStorage:', error)
    }
    
    if (newQuickFilterState) {
      // Clear any existing tag filters from modal first
      setSelectedTag("")
      setSelectedTagException("")
      setValues((values) => ({ ...values, tag: "", tagException: "" }))
    }
  }

  // Reload channels when quick filter changes
  useEffect(() => {
    if (loggedUser) {
      loadChannels(read, true)
    }
  }, [loggedUser, isQuickFilterActive])

  // Debounce hook creator
  const useDebouncedCallback = (callback, delay, deps = []) => {
    const debouncedCallback = useMemo(() => {
      return debounce(callback, delay)
    }, deps)

    useEffect(() => {
      return () => {
        debouncedCallback.cancel()
      }
    }, [debouncedCallback])

    return debouncedCallback
  }

  const onChangeMessage = (e) => {
    setInputMessage(e.target.value)
  }

  const onChangeFilterMessages = (e) => {
    setFilterMessages(e.target.value)
    const result = getHighlightedTextList(uniqueMessages, e.target.value)
    setFilteredMsgPosition(result)
  }

  // Debounced message and filter
  const debouncedFilterMessage = useDebouncedCallback(onChangeFilterMessages, 200)
  const debouncedInputMessage = useDebouncedCallback(onChangeMessage, 200)

  useEffect(() => {
    return () => {
      setFilterMessages("")
    }
  }, [debouncedFilterMessage, openHistory, openSearch])

  useEffect(() => {
    return () => {
      setInputMessage("")
    }
  }, [debouncedInputMessage])

  useEffect(() => {
    if (pinnedMessages?.length > 0 && !pinnedMessagesQuestions?.length && evidenceId) {
      addNewPinnedMessage(pinnedMessages, evidenceId)
    }
  }, [])

  const endChat = async () => {
    if (chat.isFinished) {
      await addingIsFinished(chat.id, false)
    } else {
      await addingIsFinished(chat.id, true)
    }

    dispatch(setData({ headerIsntNeeded: false }))

    if (!showOnlyChat) {
      setChat(false)
      loadChannels(read)
    }
  }

  const goToElementId = (direction = "up", itemHeight, listRef) => {
    if (!filteredMsgPosition.messages || !filteredMsgPosition.messages.length) {
      return
    }

    if (direction === "up") {
      let currentIndex =
        filteredMsgPosition.messages &&
        filteredMsgPosition.messages.findIndex((row) => row.dateId === filteredMsgPosition?.index)
      console.log("currentIndex", currentIndex)

      if (
        (currentIndex || currentIndex === 0) &&
        currentIndex < filteredMsgPosition.messages.length
      ) {
        currentIndex = filteredMsgPosition.messages[currentIndex + 1]?.dateId

        setFilteredMsgPosition((curr) => ({ ...curr, index: currentIndex }))
        console.log("messageRef[currentIndex] -> ", messageRef[currentIndex])

        messageRef[currentIndex].scrollIntoView()
      }
    }
  }

  const handleLoadMoreChannels = () => {
    loadChannels(read, false)
  }

  const handleToggleSystemChat = () => {
    setIsSystemChat(!isSystemChat)

    if (changeCurrentChat) {
      changeCurrentChat(!isSystemChat)
    }
  }

  const handleOpenAssistance = () => {
    setOpenNewAssistance((prev) => !prev)
  }

  const handleTestimonial = async (farmerDetails) => {

    console.log(farmerDetails)
    if (!farmerDetails || !farmerDetails.projectIds?.length) return

    const { projectIds, projectNames } = farmerDetails

    if (projectIds.length > 1) {
      const projectOptions = projectIds.map((value, index) => ({
        value: value,
        label: projectNames[index],
      }))

      setProjectsList(projectOptions)
      setOpenModalTestimonialSave(true)
    } else {
      const data = { farmerDetails: { ...farmerDetails, projectId: projectIds[0] }, pinnedMessages, loggedUser, saveOnlyOneMessage }
      handleSaveTestimonials(
        data,
        resetPinnedMessages,
        customToast,
        setReload,
        setFavoritedMessages,
        setIsLoadingTestimonial
      )
    }
  }

  const handleRemoveTestimonial = (farmerDetails, message) => {
    const data = { farmerDetails, message, loggedUser }
    handleRemoveSavedTestimonials(
      data,
      resetPinnedMessages,
      customToast,
      setReload,
      setFavoritedMessages,
      favoritedMessages,
      setIsLoadingTestimonial
    )
  }

  const handleCloseModalTestimonialSave = () => {
    setOpenModalTestimonialSave((prevState) => !prevState)
    resetPinnedMessages()
  }

  const handleSelectProject = (e) => {
    const data = { farmerDetails: { ...chat, projectId: e?.value }, pinnedMessages, loggedUser, saveOnlyOneMessage }
    handleSaveTestimonials(
      data,
      resetPinnedMessages,
      customToast,
      setReload,
      setFavoritedMessages,
      setIsLoadingTestimonial
    )
    handleCloseModalTestimonialSave()
  }

  const uniqueMessages = removeDuplicates(messageSortDesc)?.filter(
    (msg) => !messages.some((innerMsg) => innerMsg.resend?.id === msg.id),
  )

  const generateAccessLink = async () => {
    const toastId = toast.loading("Gerando link do Impactools Educação...")

    try {
      const response = await Send.get(`/users/the-members-magic-link/${chat.id}`)

      if (response.status !== "success") {
        throw new Error(response.status)
      }

      setInputMessage(response.link)

      toast.update(toastId, {
        render: "Link disponível",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
    } catch (error) {
      console.log("Error", error)
      toast.update(toastId, {
        render: "Erro ao gerar link de acesso.",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      })
    }
  }

  const handleNewAssitanceConfirm = () => {
    setOpenNewAssistance(false)
    navigate(
      `/farmer/profile/${chat?.id}?context=false&category=new&origin=fromChat${pathname?.includes("chat") ? `Page` : ``
      }`,
      {
        state: {
          fromChat: { ...chat, projectsByUser, assistanceTitle: getValues()?.assistanceTitle },
        },
      },
    )
    setValue("assistanceTitle", "")
  }

  useEffect(() => {
    if (resetFields) {
      setResetFields(false)
    }
  }, [resetFields])

  // Handlers for edit user functionality
  const handleEditUser = (user) => {
    setUserToEdit(user)
    setEditUserModalOpen(true)
  }

  const handleCloseEditModal = () => {
    setEditUserModalOpen(false)
    setUserToEdit(null)
  }

  const handleSaveUser = async (updatedUser) => {
    try {
      console.log({updatedUser})
      // Save to Firebase for persistence
      await db.collection('users').doc(updatedUser.id).update({
        name: updatedUser.name,
        companies: updatedUser.companies?.map(company => company.id || company.value || company) || [],
        lastUpdated: new Date()
      })

      // Update the channels state to reflect the changes
      setChannels(prevChannels => 
        prevChannels.map(channel => 
          channel.id === updatedUser.id 
            ? { ...channel, name: updatedUser.name, companies: updatedUser.companies }
            : channel
        )
      )

      // If this is the currently selected chat, update it too
      if (chat && chat.id === updatedUser.id) {
        setChat(prevChat => ({ 
          ...prevChat, 
          name: updatedUser.name, 
          companies: updatedUser.companies 
        }))
      }

      console.log('User updated successfully:', updatedUser)
    } catch (error) {
      console.error('Error saving user data:', error)
      throw error
    }
  }

  return (
    <>
      {/* Edit User Modal */}
      <EditUserModal
        isOpen={editUserModalOpen}
        onClose={handleCloseEditModal}
        user={userToEdit}
        onSave={handleSaveUser}
        loggedUserId={loggedUser?.id}
      />

      <NewChatScreen
      loggedUser={userId}
      channels={filteredChannels(channels, values, usersByTagException, isQuickFilterActive, loggedUser)}
      messages={uniqueMessages}
      unreadMessage={unreadMessage(channels)}
      {...{
        isMobile,
        handleTestimonial,
        handleToggleSystemChat,
        isSystemChat,
        showOnlyChat,
        handleLoadMoreChannels,
        debouncedFilterMessage,
        onChangeFilterMessages,
        debouncedInputMessage,
        openHistory,
        setOpenHistory,
        openSearch,
        setOpenSearch,
        messageModalIsOpen,
        setMessageModalIsOpen,
        modalNewsIsOpen,
        setModalNewsIsOpen,
        modalTermsIsOpen,
        setModalTermsIsOpen,
        modalMagicLinkIsOpen,
        openModalTestimonialSave,
        projectsList,
        handleSelectProject,
        handleCloseModalTestimonialSave,
        setModalMagicLinkIsOpen,
        chat,
        setChat,
        setTab,
        tab,
        tabOptions,
        onSendMessages,
        onKeyPress,
        onChange,
        onChangeFilterTags,
        values,
        loading,
        loadingMessage,
        setOpenPicker,
        openPicker,
        onDeleteMessage,
        uploadFiles,
        newChat,
        onTab,
        createdAt,
        channelLoading,
        setRead,
        read,
        modalFilterIsOpen,
        setModalFilterIsOpen,
        tags: formatedTags,
        tagsToFilter,
        handleTagsToFilter,
        selectedTag,
        selectedTagException,
        loadTags,
        numberOfChats,
        inputMessage,
        onChangeMessage,
        onQuickFilterClick,
        isQuickFilterActive,
        valueSearch: filterMessages,
        isFinished: chat.isFinished,
        endChat,
        goToElementId,
        messageRef,
        messageModalOpen,
        setMessageModalOpen,
        setFilteredMsgPosition,
        filteredMsgPosition,
        moreChannelLoading,
        showActions,
        handleOpenAssistance,
        openNewAssistance,
        setOpenText,
        openText,
        openVoice,
        setOpenVoice,
        generateAccessLink,
        resendMessage,
        handleCloseModal,
        formQuestionMessage,
        tagLinkIsOpen,
        setModalTagLinkIsOpen,
        reload: loadingDeleteMessage,
        clearFields,
        resetFields,
        handleNewAssitanceConfirm,
        register,
        watch,
        handleNavigateToEvidence,
        pinnedMessagesQuestions,
        resetPinnedMessagesQuestions,
        evidenceId,
        handleRemoveTestimonial,
        onEditUser: handleEditUser
      }}
    />
    </>
  )
}

export default NewChatContainer

const unreadMessage = (channels) => {
  return channels.filter((item) => item.unreadCount === 1).length > 0
    ? channels.filter((item) => item.unreadCount === 1).length
    : ""
}

const removeDuplicates = (values) => {
  return values.filter(function (a) {
    const id = a && a.id ? a.id : a
    return !this[JSON.stringify(id)] && (this[JSON.stringify(id)] = true) /* && !a.deleted; */
  }, Object.create(null))
}

export const imageNameUtils = (filename) => {
  return `${filename}-${new Date()
    .toLocaleString("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/\//g, "-")
    .replace(" ", "")}.${(filename ? filename : "").split(".").pop()}`
}

const DEBUG_FILTER = process.env.NODE_ENV === 'development'

const filteredChannels = (data, values, usersByTagException, isQuickFilterActive, loggedUser) => {
  if (DEBUG_FILTER) {
    console.log('🔧 FilteredChannels called with:', {
      dataLength: data?.length,
      isQuickFilterActive,
      userName: loggedUser?.name,
      hasValues: !!values
    })
  }
  
  let filteredUsers = (data && data?.filter((item) => item?.id)) || []

  // Apply search filter
  if (values && values.search && values.search.value !== "") {
    const searchTerm = values.search.value.toLowerCase()
    filteredUsers = filteredUsers.filter(
      (item) => item && item.name?.toLowerCase().includes(searchTerm),
    )
  }

  // Apply tag exception filter
  if (usersByTagException && usersByTagException?.length > 0) {
    filteredUsers =
      filteredUsers &&
      filteredUsers.filter((item) => usersByTagException.some((user) => user.name === item.name))
  }

  // Apply quick filter for user's name in tags if active
  if (isQuickFilterActive && loggedUser && loggedUser.name) {
    if (DEBUG_FILTER) {
      console.log('🔍 Applying quick filter for user:', loggedUser.name)
      console.log('📊 Total channels before quick filter:', filteredUsers.length)
    }
    
    const userName = loggedUser.name.toLowerCase()
    const matchingChannels = []
    
    filteredUsers.forEach((item, index) => {
      // Check if any of the item's tags contain the user's name
      if (item.tags && Array.isArray(item.tags)) {
        if (DEBUG_FILTER) {
          console.log(`🏷️ Channel "${item.name}" has ${item.tags.length} tags:`, item.tags.map(t => t.name))
        }
        const matchingTags = item.tags.filter(tag => 
          tag.name?.toLowerCase().includes(userName)
        )
        
        if (matchingTags.length > 0) {
          if (DEBUG_FILTER) {
            console.log(`✅ Found matching channel: "${item.name}" with tags:`, matchingTags.map(t => t.name))
          }
          matchingChannels.push(item)
        }
      } else if (DEBUG_FILTER) {
        console.log(`❌ Channel "${item.name}" has no tags or tags is not array:`, item.tags)
      }
    })
    
    filteredUsers = matchingChannels
    if (DEBUG_FILTER) {
      console.log('📊 Total channels after quick filter:', filteredUsers.length)
    }
    
    if (filteredUsers.length === 0) {
      console.log('⚠️ No channels found with tags containing user name. Available channels with tags:')
      const channelsWithTags = data.filter(item => item.tags && item.tags.length > 0)
      channelsWithTags.slice(0, 5).forEach(item => {
        console.log(`   - "${item.name}": [${item.tags.map(t => t.name).join(', ')}]`)
      })
      if (channelsWithTags.length > 5) {
        console.log(`   ... and ${channelsWithTags.length - 5} more channels with tags`)
      }
    }
  }

  return filteredUsers
}

export const filteredMessages = (data, filterMessages, openHistory) => {
  let filteredMessages = data || []

  const keySearch = openHistory ? "message" : "content"

  if (filterMessages && filterMessages !== "" && keySearch) {
    filteredMessages = data.filter((item) =>
      item[keySearch]?.toLowerCase().includes(filterMessages?.toLowerCase()),
    )
  }

  return filteredMessages
}
